import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CellTable from "../../../components/CellTable";

import { converterLoja, converterNumero } from "../../../util/loja";
import {
  CellYearContainer,
  ContainerCellAside,
} from "../../../components/CellTableYear/styles";
import CellTablePorcentagem from "../../../components/CellTablePorcentagem";

const CellTableYear = ({
  qtd,
  valorTotal,
  tickerMedio,
  lucro,
  representatividade,
  representatividadeGrupoNaLoja,
  variacao,
}) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="button-tooltip-2">
          <p>Quantidade: {qtd}</p>
          <p>Valor Total: {converterNumero(valorTotal)}</p>
          <p>Ticket Médio: {converterNumero(tickerMedio)}</p>
          <p>Lucro Bruto: {lucro}</p>
          <p>Representatividade da loja no grupo: {representatividade}%</p>
          <p>
            Representatividade do grupo na loja: {representatividadeGrupoNaLoja}
            %
          </p>
          <p>Variação: {variacao?.toFixed(2)}%</p>
        </Tooltip>
      }
    >
      <CellYearContainer>
        <div>
          <span>{qtd}</span>
        </div>
        <div>
          <span>{converterNumero(valorTotal)}</span>
        </div>
        <div>
          <span>{converterNumero(tickerMedio)}</span>
        </div>
        <div>
          <span>{lucro}</span>
        </div>
        <div>
          <span>{representatividade}%</span>
        </div>
        <div>
          <span>{representatividadeGrupoNaLoja}%</span>
        </div>
        <div>
          <CellTablePorcentagem rowInfo={variacao} desemp={true} />
        </div>
      </CellYearContainer>
    </OverlayTrigger>
  );
};

const CellAsideTodasInfo = () => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="button-tooltip-2">
          {" "}
          <p>QTD</p>
          <p>Valor Total</p>
          <p>TKM</p>
          <p>Lucro Bruto</p>
          <p>Representatividade da loja no grupo</p>
          <p>Representatividade do grupo na loja</p>
          <p>Variação</p>
        </Tooltip>
      }
    >
      {({ ref, ...triggerHandler }) => (
        <ContainerCellAside
          ref={ref}
          {...triggerHandler}
          style={{ width: "115px" }}
        >
          <strong>QTD</strong>
          <strong>Valor Total</strong>
          <strong>TKM</strong>
          <strong>Lucro Bruto</strong>
          <strong>Rep. grupo</strong>
          <strong>Rep. loja</strong>
          <strong>Variação</strong>
        </ContainerCellAside>
      )}
    </OverlayTrigger>
  );
};

const celulaLoja = (item, linha, loja, dadosTabela) => {
  const anoAtual = linha.find((item) => item.anoAtual);
  const anoAnterior = linha.find((item) => item.anoAnterior);
  if (!anoAtual) {
    return "N/A";
  }

  const dadosLojaAnoAtual = anoAtual.dados.find(
    (item) => item.CodLoja === loja
  );

  const totalValorTodasLojas = anoAtual.dados.reduce(
    (acc, item) => acc + (item.VlrTotal || 0),
    0
  );

  if (dadosLojaAnoAtual && totalValorTodasLojas > 0) {
    dadosLojaAnoAtual.representatividade = parseFloat(
      ((dadosLojaAnoAtual.VlrTotal / totalValorTodasLojas) * 100).toFixed(2)
    );
  }

  if (dadosLojaAnoAtual && anoAnterior) {
    const dadosLojaAnoAnterior = anoAnterior.dados.find(
      (item) => item.CodLoja === loja
    );

    if (dadosLojaAnoAnterior) {
      const valorAnoAnterior = dadosLojaAnoAnterior.VlrTotal || 0;
      const valorAnoAtual = dadosLojaAnoAtual.VlrTotal || 0;

      dadosLojaAnoAtual.variacao = valorAnoAnterior
        ? ((valorAnoAtual - valorAnoAnterior) / valorAnoAnterior) * 100
        : 0;
    }
  }

  const lucro = !isNaN(
    parseFloat(
      parseFloat(dadosLojaAnoAtual?.VlrLucroBrutoPorcentagem).toFixed(2)
    )
  )
    ? parseFloat(
        parseFloat(
          Number(
            (dadosLojaAnoAtual?.VlrTotal - dadosLojaAnoAtual?.VlrCusto) /
              dadosLojaAnoAtual?.VlrTotal
          ) * 100
        ).toFixed(2)
      )
    : 0;

  let representatividadeGrupoNaLoja = 0;
  if (dadosLojaAnoAtual && dadosTabela.length > 0) {
    // Soma o total do grupo na loja (ano atual)
    const totalGrupoNaLoja = dadosTabela.reduce((acc, grupo) => {
      const anoAtualGrupo = grupo.find((item) => item.anoAtual);
      if (!anoAtualGrupo) return acc;
      const dadosLoja = anoAtualGrupo.dados.find((d) => d.codLoja === loja);
      return acc + (dadosLoja?.vlrTotal || 0);
    }, 0);

    // Valor do grupo atual na loja (ano atual)
    const valorGrupoAtualNaLoja = dadosLojaAnoAtual.vlrTotal || 0;

    // Calcula a representatividade do grupo na loja
    representatividadeGrupoNaLoja =
      totalGrupoNaLoja > 0
        ? parseFloat(
            ((valorGrupoAtualNaLoja / totalGrupoNaLoja) * 100).toFixed(2)
          )
        : 0;
    dadosLojaAnoAtual.representatividadeGrupoNaLoja =
      representatividadeGrupoNaLoja;
  }

  return (
    <CellTableYear
      qtd={dadosLojaAnoAtual?.totalPedidos || 0}
      valorTotal={dadosLojaAnoAtual?.VlrTotal || 0}
      tickerMedio={dadosLojaAnoAtual?.ticketMedio || 0}
      lucro={lucro}
      representatividade={dadosLojaAnoAtual?.representatividade || 0}
      representatividadeGrupoNaLoja={
        dadosLojaAnoAtual?.representatividadeGrupoNaLoja || 0
      }
      variacao={dadosLojaAnoAtual?.variacao || 0}
    />
  );
};

export const colunasTabelaPorLoja = (lojas = false, dadosTabela = []) => {
  let columns = [];

  columns = [
    {
      dataField: "grupo",
      text: "Fornecedor",
      style: () => {
        return { verticalAlign: "middle" };
      },
      formatter: (cell, row) => {
        if (!row[0]?.codGrupo) {
          return "";
        }
        return row[0]?.codGrupo + " - " + row[0]?.nomeGrupo || "";
      },
    },
    {
      text: "",
      dataField: "",
      align: () => {
        return "left";
      },
      formatter: (cell) => {
        return <CellAsideTodasInfo />;
      },
      csvFormatter: (cell, row, rowIndex) => "AT \nAN",
      width: "115px",
    },
    ...lojas.map((loja) => ({
      dataField: loja.toString(),
      text: converterLoja(loja),
      style: () => {
        return { verticalAlign: "middle" };
      },
      formatter: (cell, index) => {
        return celulaLoja(cell, index, loja, dadosTabela);
      },
    })),
  ];

  return columns;
};
